var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"treelist",class:{ 'treelist-root': _vm.depth == 0 }},_vm._l((_vm.items),function(item,index){return _c('template-menu',{key:_vm.depth + '-' + index,attrs:{"items":item.items,"href":item.href,"label":item.text,"depth":_vm.depth + 1}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }